"use strict";
/**
 * Time formatting utilities for LingoShade
 * Centralized time formatting to eliminate duplication across apps
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatAudioTime = exports.formatDictationTime = exports.formatDuration = exports.formatTimeMilliseconds = exports.formatTimeSeconds = void 0;
exports.formatTime = formatTime;
/**
 * Universal time formatting function
 * Handles both seconds and milliseconds input with various output formats
 */
function formatTime(value, options = { unit: "seconds", format: "auto" }) {
    const { unit, format, showHours = false, showTenths = false } = options;
    // Normalize to seconds
    const totalSeconds = unit === "milliseconds" ? value / 1000 : value;
    // Handle invalid input
    if (isNaN(totalSeconds) || totalSeconds < 0) {
        return "0:00";
    }
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = Math.floor(totalSeconds % 60);
    const tenths = Math.floor((totalSeconds % 1) * 10);
    // Auto format based on duration
    if (format === "auto") {
        if (hours > 0 || showHours) {
            return `${hours}:${minutes.toString().padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`;
        }
        if (showTenths && unit === "milliseconds") {
            return `${minutes}:${seconds.toString().padStart(2, "0")}.${tenths}`;
        }
        return `${minutes}:${seconds.toString().padStart(2, "0")}`;
    }
    // Specific formats
    switch (format) {
        case "HH:MM:SS":
            return `${hours}:${minutes.toString().padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`;
        case "MM:SS":
            return `${minutes}:${seconds.toString().padStart(2, "0")}`;
        case "SS":
            return showTenths
                ? `${totalSeconds.toFixed(1)}s`
                : `${Math.round(totalSeconds)}s`;
        default:
            return `${minutes}:${seconds.toString().padStart(2, "0")}`;
    }
}
/**
 * Convenient shortcuts for common use cases
 */
/** Format seconds as MM:SS or HH:MM:SS automatically */
const formatTimeSeconds = (seconds) => formatTime(seconds, { unit: "seconds", format: "auto" });
exports.formatTimeSeconds = formatTimeSeconds;
/** Format milliseconds as MM:SS automatically */
const formatTimeMilliseconds = (ms) => formatTime(ms, { unit: "milliseconds", format: "auto" });
exports.formatTimeMilliseconds = formatTimeMilliseconds;
/** Format duration with optional hours display */
const formatDuration = (seconds, showHours = false) => formatTime(seconds, { unit: "seconds", format: "auto", showHours });
exports.formatDuration = formatDuration;
/** Format short time for dictation results (handles both ms and seconds) */
const formatDictationTime = (value, isMilliseconds = true) => {
    if (isMilliseconds) {
        const seconds = Math.round(value / 1000);
        const minutes = Math.floor(seconds / 60);
        const remainingSeconds = seconds % 60;
        if (minutes > 0) {
            return `${minutes}:${remainingSeconds.toString().padStart(2, "0")}`;
        }
        return `${seconds}s`;
    }
    return (0, exports.formatTimeSeconds)(value);
};
exports.formatDictationTime = formatDictationTime;
/** Format for audio player progress displays */
const formatAudioTime = (seconds) => formatTime(seconds, { unit: "seconds", format: "auto", showHours: false });
exports.formatAudioTime = formatAudioTime;
//# sourceMappingURL=timeFormatting.js.map